module.exports = __webpack_public_path__ + "img/face-3.6c4b7c7f.png";